import { createImageBitmap } from "react-easy-crop";
export const dataURLtoBlob = (dataURL) => {
    try {
        if (!dataURL || typeof dataURL !== "string") {
            throw new Error("Invalid dataURL: Expected a non-empty string.");
        }

        const parts = dataURL.split(",");
        if (parts.length !== 2) {
            throw new Error("Invalid Base64 format: Data URL must have a MIME type and encoded data.");
        }

        const mimeMatch = parts[0].match(/:(.*?);/);
        if (!mimeMatch) {
            throw new Error("Invalid MIME type: Data URL must contain a valid MIME.");
        }

        const mimeString = mimeMatch[1]; // Extract MIME type
        const byteString = atob(parts[1]); // Decode Base64 string
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const uint8Array = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
        }

        return new Blob([uint8Array], { type: mimeString });
    } catch (error) {
        console.error("Error converting Data URL to Blob:", error.message);
        return null; // Return null if conversion fails
    }
};




export const getCroppedImg = async (imageSrc, croppedAreaPixels) => {
    try {
        const image = await createImage(imageSrc);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        if (!ctx) {
            throw new Error("Could not get canvas context.");
        }

        canvas.width = croppedAreaPixels.width;
        canvas.height = croppedAreaPixels.height;

        ctx.drawImage(
            image,
            croppedAreaPixels.x,
            croppedAreaPixels.y,
            croppedAreaPixels.width,
            croppedAreaPixels.height,
            0,
            0,
            croppedAreaPixels.width,
            croppedAreaPixels.height
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    reject(new Error("Failed to create blob from canvas."));
                    return;
                }
                resolve(blob);
            }, "image/png");
        });
    } catch (error) {
        console.error("Error cropping image:", error);
        return null;
    }
};

const createImage = (url) =>
    new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = url;
        img.onload = () => resolve(img);
        img.onerror = (error) => reject(error);
    });
export const debounce = (func, delay) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func(...args), delay);
    };
};

export const CountryFlag = ({ countryCode }) => {
    const flagUrl = `https://flagcdn.com/w320/${countryCode && countryCode?.toLowerCase()}.png`;
    return flagUrl;
};

export const convertBlobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
        try {
            // Validate input
            if (!(blob instanceof Blob)) {
                reject(new Error("Invalid input: Expected a Blob object."));
                return;
            }

            // Ensure blob is not empty
            if (blob.size === 0) {
                reject(new Error("Blob is empty. Cannot convert to Base64."));
                return;
            }

            const reader = new FileReader();

            reader.onloadend = () => {
                // Validate Base64 output
                if (typeof reader.result !== "string" || !reader.result.startsWith("data:image/")) {
                    reject(new Error("Invalid Base64 output. Ensure the input is a valid image Blob."));
                    return;
                }

                resolve(reader.result);
            };

            reader.onerror = () => {
                reject(new Error("Error reading the Blob. Conversion to Base64 failed."));
            };

            reader.readAsDataURL(blob);
        } catch (error) {
            reject(new Error("Unexpected error during Blob to Base64 conversion: " + error.message));
        }
    });
